// extracted by mini-css-extract-plugin
module.exports = {"container":"FullPageCart_container___LH23","titles":"FullPageCart_titles__5yCz0","titleSubtitle":"FullPageCart_titleSubtitle__bQnT6","slider":"FullPageCart_slider__B9Zyf"};